var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n            fill: #006b87;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "delete_24dp_5F6368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4711",
    className: "cls-1",
    d: "M12,6.8v7.5h-6v-7.5h6M10.9,2.3h-3.8l-.8.8h-2.6v1.5h10.5v-1.5h-2.6l-.8-.8ZM13.5,5.3H4.5v9c0,.8.7,1.5,1.5,1.5h6c.8,0,1.5-.7,1.5-1.5V5.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/Icon_Delete.5203c07dce2a1c53c185e68c17f5e6ce.svg";
export { ForwardRef as ReactComponent };